export default {"src":"/_next/static/media/bottom-arrow.e3850284.svg","height":308,"width":80,"blurWidth":0,"blurHeight":0};